/*
 * Licensed to the Apache Software Foundation (ASF) under one or more
 * contributor license agreements.  See the NOTICE file distributed with
 * this work for additional information regarding copyright ownership.
 * The ASF licenses this file to You under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with
 * the License.  You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import { useCallback, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

function useNetworkOfflineMode(
  offlineStatuses = [502, 504, 404],
  offlineRoute = '/offline'
) {
  const history = useHistory()
  const [status, setStatus] = useState()
  const [response, setResponse] = useState()

  const handleOfflineMode = useCallback((statusCode, xhrResponse) => {
    setStatus(statusCode)
    setResponse(xhrResponse)
  }, [])

  useEffect(() => {
    if (status && response && offlineStatuses.includes(status)) {
      history.push(offlineRoute)
    }
  }, [status, response, offlineStatuses, offlineRoute, history])

  return {
    handleOfflineMode,
    response
  }
}

export default useNetworkOfflineMode
